import './scss/FreeText.scss'

function Text({data}) {
	return (
		<div className="textElement" style={{marginTop:data?.marginTop, padding: '5px', textAlign: data?.textAlign, background: data ?.background, color: data ?.textColor}} dangerouslySetInnerHTML={{__html: data?.html}}></div>
	);
};
export default Text;
